export default __webpack_public_path__ + "static/media/Report-documentation.99647b86.md";